/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/es'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { locale });

import 'slick-carousel/slick/slick.css';

import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: {
        sm: 640,
        md: 768,
        lg: 1280,
        xl: 1600,
    },
})
window.Vue = require('vue').default;

Vue.directive('number-only', {
  bind: function(el) {
    el.addEventListener('keydown', function(e) {
      // Permite: retroceso, eliminar, tabulación, escape
      if ([8, 9, 27].includes(e.keyCode) ||
        // Permite: inicio, fin, izquierda, derecha, abajo, arriba
        (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }

      // Asegura que solo se ingresen números
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }

      // Impide los caracteres ",", "+", "." cuando ya existen en el valor actual del campo
      const inputValue = el.value;
      if ([188, 190, 187].includes(e.keyCode)) {
        if (inputValue.includes(',') || inputValue.includes('.') || inputValue.includes('+')) {
          e.preventDefault();
        }
      }
    });

    el.addEventListener('input', function(e) {
      const inputValue = el.value;
      const regex = /^[0-9]*$/;

      if (!regex.test(inputValue)) {
        el.value = inputValue.replace(/[^0-9]/g, '');
      }
    });
  }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('initial-loading', require('./components/Utils/InitialLoading.vue').default);
Vue.component('loading', require('./components/Utils/Loading.vue').default);
Vue.component('cookies', require('./components/Utils/Cookies.vue').default);

Vue.component('user-profile', require('./components/User/Profile.vue').default);

Vue.component('catalog-index', require('./components/Catalog/CatalogIndex.vue').default);
Vue.component('product-detail', require('./components/Catalog/ProductDetail.vue').default);
Vue.component('shopping-cart', require('./components/Shpping-cart/ShoppingCart.vue').default);
Vue.component('shopping-cart-header', require('./components/Shpping-cart/ShoppingCartHeader.vue').default);

Vue.component('compliance-home', require('./components/Compliance/Home.vue').default);
Vue.component('compliance-seller', require('./components/Compliance/HomeSeller.vue').default);
Vue.component('compliance-simulator', require('./components/Compliance/Simulator.vue').default);
Vue.component('metrics-rv', require('./components/Compliance/MetricsRV.vue').default);
Vue.component('metrics-rv-simulator', require('./components/Compliance/MetricsRVSimulator.vue').default);
Vue.component('banner-home', require('./components/Utils/BannerHome.vue').default);
Vue.component('new-banners', require('./components/Utils/Banners.vue').default);
Vue.component('outstanding-home', require('./components/Utils/OutstandingHome.vue').default);
Vue.component('partial-discount', require('./components/Home/PartialDiscount.vue').default);
Vue.component('popups-home', require('./components/Utils/PopupsHome.vue').default);
Vue.component('redeem-home', require('./components/Home/RedeemHome.vue').default);

Vue.component('popups-variable-rent', require('./components/Utils/PopupsVariableRent.vue').default);
Vue.component('popups-wildcard', require('./components/Utils/PopupsWildcard.vue').default);

Vue.component('home-manager', require('./components/Home/HomeManager.vue').default);
Vue.component('home-staff', require('./components/Home/HomeStaff.vue').default);
Vue.component('home-staff-card', require('./components/Home/HomeStaffCard.vue').default);
Vue.component('home-shopkeeper', require('./components/Home/HomeShopkeeper.vue').default);
Vue.component('home-shopkeeper-card', require('./components/Home/HomeShopkeeperCard.vue').default);
Vue.component('calculator-tci', require('./components/Home/CalculatorTCI.vue').default)

Vue.component('learning-index', require('./components/Learning/LearningIndex.vue').default);
Vue.component('learning-content', require('./components/Learning/LearningContent.vue').default);
Vue.component('learning-quiz', require('./components/Learning/LearningQuiz.vue').default);
Vue.component('learning-feedback-quiz', require('./components/Learning/LearningFeedbackQuiz.vue').default);
Vue.component('delete-account', require('./components/User/DeleteAccount.vue').default);

Vue.component('show-iframe', require('./components/Utils/ShowIframe.vue').default);

Vue.component('discounts-index', require('./components/Discounts/DiscountsIndex.vue').default);

Vue.component('survey-index', require('./components/Survey/SurveyIndex.vue').default);
Vue.component('survey-question', require('./components/Survey/SurveyQuestion.vue').default);

Vue.component('news-index', require('./components/News/NewsIndex.vue').default);
Vue.component('news-show', require('./components/News/NewsShow.vue').default);

Vue.component('alphabet-soup-index', require('./components/Challenges/AlphabetSoupIndex.vue').default);
Vue.component('memento', require('./components/Challenges/Memento.vue').default);

// Header & Footer
Vue.component('header-vue', require('./components/Utils/Header.vue').default);
Vue.component('footer-vue', require('./components/Utils/Footer.vue').default);


Vue.component('notifications', require('./components/Utils/Notifications.vue').default);

Vue.component('novedades-home', require('./components/Home/NovedadesHome.vue').default);


Vue.component('win-points', require('./components/Win-points/WinPoints.vue').default);
Vue.component('win-points-card', require('./components/Win-points/WinPointsCard.vue').default);
Vue.component('insitu-buttons-home', require('./components/Utils/InsituButtonsHome.vue').default);

Vue.component('popups-update-data', require('./components/User/PopupsUpdateData.vue').default);

Vue.component('redemptions-popups', require('./components/RedemptionsPopups/RedemptionsPopups.vue').default);
// Voyager login page
Vue.component('voyager-login', require('./components/Admin/VoyagerLogin.vue').default);
Vue.component('searching-character-index', require('./components/Entertainment/SearchingCharacterIndex.vue').default);

Vue.component('season', require('./components/Season/Season.vue').default);
Vue.component('ranking', require('./components/Season/Ranking.vue').default);

//TermsPolicy
Vue.component('datapolicy', require('./components/TermsPolicy/Datapolicy.vue').default);
Vue.component('upload-photo', require('./components/Challenges/UploadPhoto.vue').default);
Vue.component('login', require('./components/Auth/Login.vue').default);

Vue.component('frequent-questions', require('./components/FrequentQuestions/FrequentQuestions.vue').default);

Vue.component('staff-detail', require('./components/Staff/StaffDetail.vue').default);
Vue.component('staff', require('./components/Staff/StaffIndex.vue').default);
Vue.component('staff-user-request', require('./components/Staff/RequestUserStaff.vue').default);
Vue.component('staff-requests', require('./components/ManagerUserStaff/StaffRequests.vue').default);
Vue.component('staff-progress', require('./components/Staff/yourStaffProgress.vue').default);
Vue.component('staff-transfer-user', require('./components/Staff/TransferUserStaff.vue').default);
Vue.component('staff-transfers', require('./components/Staff/StaffTransfers.vue').default);

Vue.component('dropdowns-staff', require('./components/Home/DropdownsStaff.vue').default);

Vue.component('season-status-staff', require('./components/Utils/SeasonStatusStaff.vue').default);
Vue.component('insitu-buttons-staff', require('./components/Utils/InsituButtonsStaff.vue').default);
Vue.component('no-data-staff', require('./components/Utils/NoDataStaff.vue').default);
Vue.component('your-progress', require('./components/Staff/yourProgress.vue').default);
Vue.component('legal-disclaimer', require('./components/Utils/LegalDisclaimer.vue').default);

Vue.component('change-password', require('./components/Auth/ChangePassword.vue').default);

export var EventBus = new Vue();

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
